"use client";

import { BrandPageQueryObj } from "@faire/retailer-shared/search/BrandPageQueryObj";
import { useRouteMatch } from "@faire/web-api/pathMatchesRoute";
import React, { useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";

import { ILeanBrandTile } from "@faire/retailer/components/LeanBrandTileRenderer/ILeanBrandTileAdapters";
import { LeanBrandTileRendererForCarousel } from "@faire/retailer/components/LeanBrandTileRenderer/LeanBrandTileRendererForCarousel";
import { SDUIOnClickHandler } from "@faire/retailer/components/SDUI/__internal__/SDUIOnClickHandler";
import { SDUITileInstanceRendererProps } from "@faire/retailer/components/SDUI/ComponentRenderers/Tile/__internal__/types";

import { getQueryParamsForSurface } from "./tileUrlHelpers";

export const SDUIBrandTileRenderer = ({
  tileElement,
  loggingData,
  renderBehaviour,
}: SDUITileInstanceRendererProps) => {
  const { on_click } = tileElement;
  const { brand } = tileElement.brand_tile ?? {};
  const leanBrandTile = useMemo(
    () => ILeanBrandTile.fromIBrandTile(brand),
    [brand]
  );
  const location = useLocation();
  const match = useRouteMatch();

  const brandTileQueryParams = useCallback(() => {
    if (loggingData.view_display_page === undefined) {
      return {};
    }
    return getQueryParamsForSurface(
      loggingData.view_display_page,
      location,
      match
    ) as BrandPageQueryObj;
  }, [loggingData, location, match]);

  return (
    <SDUIOnClickHandler
      onClickActions={on_click}
      loggingData={loggingData}
      logLegacyClickEvent
    >
      <LeanBrandTileRendererForCarousel
        leanBrandTile={leanBrandTile}
        brandPageQueryParams={brandTileQueryParams}
        useLazyImageLoading={renderBehaviour?.imagesLoadingStrategy === "lazy"}
      />
    </SDUIOnClickHandler>
  );
};
